export default __webpack_public_path__ + "static/media/uploader-abbottLibre-1.b6015afe.png";